import {
  CROSS_PCT,
  getCornerSize,
  getCornerX,
  getCornerY,
  type KarelEnvironment,
} from '../util';

interface GridBackgroundProps {
  state: KarelEnvironment;
}

export const GridBackground = ({state}: GridBackgroundProps) => {
  // eslint-disable-next-line no-var -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  var lines = [];
  // eslint-disable-next-line no-var -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  for (var r = 0; r < state.worldState.nRows; r++) {
    // eslint-disable-next-line no-var -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    for (var c = 0; c < state.worldState.nCols; c++) {
      // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      let cornerSize = getCornerSize(state);
      // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      let x = getCornerX(state, r, c) + 0.5 * cornerSize;
      // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      let y = getCornerY(state, r, c) + 0.5 * cornerSize;
      // eslint-disable-next-line prefer-const -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      let crossSize = cornerSize * CROSS_PCT;
      lines.push(
        <div
          className="karel-cross"
          style={{
            marginLeft: x - crossSize / 2,
            marginTop: y - 1,
            width: crossSize,
            height: 2,
          }}
          key={r + ',' + c + '1'}
        ></div>,
      );
      lines.push(
        <div
          className="karel-cross"
          style={{
            marginLeft: x - 1,
            marginTop: y - crossSize / 2,
            width: 2,
            height: crossSize,
          }}
          key={r + ',' + c + '2'}
        ></div>,
      );
    }
  }
  return <div style={{position: 'absolute'}}>{lines}</div>;
};
